import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import {
  Box,
  Container,
  Typography,
  Grid,
  Modal,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { fetchGalleryImages } from "../redux/actions/admin/galleryAction";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import GalleryBanner from "../assets/Gallery.png";

const Gallery = () => {
  const dispatch = useDispatch();
  const { images } = useSelector((state) => state.gallery);

  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    dispatch(fetchGalleryImages());
  }, [dispatch]);

  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Gallery - Shree Mangalam School"
        description="Explore memorable moments and vibrant campus life at Shree Mangalam School through our photo gallery. See events, achievements, and student activities."
        url="/gallery"
        keywords="school gallery, Shree Manglam gallery, student events, campus photos, RIMC coaching events"
      />
      <Header image={GalleryBanner} alt={"Gallery Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
            p: 1,
          }}
          gutterBottom
        >
          Celebrating Every Moment
        </Typography>

        <Grid container spacing={3} pt={1} mb={5} mt={3}>
          {images?.map((image, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: "15px",
                  overflow: "hidden",
                  boxShadow: 3,
                  cursor: "pointer",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
                onClick={() => handleOpen(image.imageUrl)}
              >
                <img
                  src={image.imageUrl}
                  alt={`uploaded-banner-${index}`}
                  style={{
                    height: "350px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Image Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            width: { xs: "90vw", sm: "80vw", md: "70vw" },
            maxHeight: "90vh",
            overflow: "auto",
            borderRadius: 2,
            outline: "none",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 2,
              backgroundColor: "#fff",
              "&:hover": {
                backgroundColor: "#eee",
              },
            }}
          >
            <CloseIcon sx={{ color: "#065A79" }} />
          </IconButton>

          <Box sx={{ p: 2 }}>
            <img
              src={selectedImage}
              alt="Zoomed Gallery"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "75vh",
                borderRadius: "8px",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Box>
        </Box>
      </Modal>

      <Footer />
    </>
  );
};

export default Gallery;
